module.exports = __webpack_public_path__ + "img/1d38386.png";